export default __webpack_public_path__ + "static/media/fa-regular-400.0fe94285.woff2";